/* Waco Diamonds — per-card ring configurator (collection cards).
   Each combined-listing ring card gets a quiet "Customize" disclosure (collapsed by default):
   Metal Karat + Diamond Quality as inline text toggles, Carat as a slim slider (Metal Color is
   the existing swatch row). Changing any control updates THAT card's price live from its
   data-waco-price-matrix. Every price shown is a real matrix value — presentation only.

   Loaded only on the engagement collection (via the Waco Style Tiles section). The card markup
   also renders a [data-waco-per-card-pricer] marker so the GLOBAL filter-panel pricer
   (waco-collection-pricer.js) stands down here — both write the same price node and would fight.

   Metal colour never changes price (karat+carat+quality fully determine it), so colour stays on
   the existing swatch handler (image + click-through) and is ignored for pricing. */
(function () {
  "use strict";
  if (window.__wacoCardConfigurator) return;
  window.__wacoCardConfigurator = true;

  var KARAT_ORDER = ["10K", "14K", "18K", "Platinum"];
  var QUALITY_ORDER = ["Good (F / VS1)", "Better (E / VVS2)", "Best (D / VVS1)"];

  function qLabel(v) { return v.split(" (")[0]; }          // "Good (F / VS1)" -> "Good"
  function esc(s) { return String(s).replace(/"/g, "&quot;"); }

  // Money format inferred from the card's own rendered price, so our number matches its
  // currency / separators / decimals exactly (mirrors waco-collection-pricer.js).
  function inferFormat(sample) {
    var firstDigit = sample.search(/\d/);
    if (firstDigit < 0) return { prefix: "$", suffix: "", decimals: 0, lead: "" };
    var lastDigit = -1;
    for (var i = sample.length - 1; i >= 0; i--) { if (/\d/.test(sample[i])) { lastDigit = i; break; } }
    var leadAll = sample.slice(0, firstDigit);
    var suffix = sample.slice(lastDigit + 1);
    var core = sample.slice(firstDigit, lastDigit + 1);
    var pm = leadAll.match(/[^0-9A-Za-z\s]+\s*$/);
    var prefix = pm ? pm[0].trim() : "";
    var decimals = /[.,]\d{2}$/.test(core) ? 2 : 0;
    return { prefix: prefix, suffix: suffix, decimals: decimals, lead: "" };
  }
  function fmt(amount, f) {
    var fixed = Number(amount).toFixed(f.decimals);
    var parts = fixed.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return f.prefix + parts[0] + (parts[1] ? "." + parts[1] : "") + f.suffix;
  }
  function priceNode(card) {
    return card.querySelector(".card-product-content__price .price__regular span:not(.visually-hidden)");
  }

  function parse(card) {
    var raw = card.getAttribute("data-waco-price-matrix");
    if (!raw) return null;
    var m; try { m = JSON.parse(raw); } catch (e) { return null; }
    var K = {}, C = {}, Q = {};
    Object.keys(m).forEach(function (key) { var p = key.split("|"); K[p[0]] = 1; C[p[1]] = 1; Q[p[2]] = 1; });
    return {
      matrix: m,
      karats: Object.keys(K).sort(function (a, b) { return KARAT_ORDER.indexOf(a) - KARAT_ORDER.indexOf(b); }),
      carats: Object.keys(C).sort(function (a, b) { return parseFloat(a) - parseFloat(b); }),
      quals: Object.keys(Q).sort(function (a, b) { return QUALITY_ORDER.indexOf(a) - QUALITY_ORDER.indexOf(b); }),
    };
  }

  function opt(value, label, title, active) {
    return '<button type="button" class="waco-cfg__opt' + (active ? " is-active" : "") +
      '" data-waco-cfg-val="' + esc(value) + '" title="' + esc(title) + '" aria-pressed="' + (active ? "true" : "false") + '">' +
      label + "</button>";
  }
  function toggleField(dim, label, opts) {
    return '<div class="waco-cfg__field">' +
      '<span class="waco-cfg__label">' + label + "</span>" +
      '<div class="waco-cfg__toggles" data-waco-cfg-dim="' + dim + '" role="group" aria-label="' + label + '">' + opts + "</div>" +
      "</div>";
  }
  // Carat is a slim range slider (min..max over the available carats) with a live "X ct" readout —
  // replaces the long pill row. Snaps to real carats on input; step = the grid's smallest gap.
  function caratField(carats, selValue) {
    var min = carats[0], max = carats[carats.length - 1], step = 0.5;
    if (carats.length > 1) {
      step = Infinity;
      for (var i = 1; i < carats.length; i++) { var d = parseFloat(carats[i]) - parseFloat(carats[i - 1]); if (d > 0 && d < step) step = d; }
      if (!isFinite(step) || step <= 0) step = 0.5;
    }
    // Ruler treatment (same as the PDP's waco-carat-slider.js): a vertical tick
    // line painted on the track at each real carat stop — taller at whole carats,
    // shorter at halves — plus the whole-carat numbers under the track, so the
    // capsule reads like a carat ruler everywhere carat is selected. Tick centers
    // track the thumb path (10px padding + half the 24px thumb, minus the 2px tile
    // that background-position % resolves against).
    var span = parseFloat(max) - parseFloat(min);
    var tickImgs = [], tickPos = [], tickSizes = [], labels = [], wholes = [];
    for (var di = 0; di < carats.length; di++) {
      var f = span ? (parseFloat(carats[di]) - parseFloat(min)) / span : 0.5;
      var whole = parseFloat(carats[di]) % 1 === 0;
      var ink = whole ? 'rgba(51,54,36,0.42)' : 'rgba(51,54,36,0.24)';
      tickImgs.push('linear-gradient(' + ink + ',' + ink + ')');
      tickPos.push('calc(21px + (100% - 42px) * ' + f.toFixed(4) + ') 50%');
      tickSizes.push(whole ? '2px 18px' : '2px 10px');
      if (whole) wholes.push({ v: carats[di], f: f });
    }
    if (wholes.length < 2) wholes = [{ v: min, f: 0 }, { v: max, f: 1 }]; // fallback: anchor min/max
    for (var wi = 0; wi < wholes.length; wi++) {
      labels.push('<span style="left:calc(21px + (100% - 42px) * ' + wholes[wi].f.toFixed(4) + ')">' +
        esc(wholes[wi].v) + (wi === wholes.length - 1 ? ' ct' : '') + '</span>');
    }
    var tickStyle = 'background-image:' + tickImgs.join(',') + ';background-position:' + tickPos.join(',') +
      ';background-size:' + tickSizes.join(',') + ';background-repeat:no-repeat';
    return '<div class="waco-cfg__field waco-cfg__field--carat">' +
      '<div class="waco-cfg__carat-head"><span class="waco-cfg__label">Carat Size</span>' +
      '<span class="waco-cfg__carat-val" data-waco-carat-val>' + esc(selValue) + " ct</span></div>" +
      '<input type="range" class="waco-cfg__slider" data-waco-cfg-dim="carat" min="' + min + '" max="' + max +
      '" step="' + step + '" value="' + esc(selValue) + '" aria-label="Carat weight" style="' + tickStyle + '">' +
      '<div class="waco-cfg__rulerlabels" aria-hidden="true">' + labels.join('') + '</div>' +
      "</div>";
  }

  function reprice(card) {
    var node = priceNode(card), data = card.__wacoData, sel = card.__wacoSel;
    if (!node || !data || !sel) return;
    if (!card.__wacoFmt) card.__wacoFmt = inferFormat((card.__wacoDefaultText || node.textContent).trim());
    var amt = data.matrix[sel.k + "|" + sel.c + "|" + sel.q];
    if (amt == null) return; // this ring doesn't offer the combo — leave the price as-is
    node.textContent = fmt(amt, card.__wacoFmt);
    var priceEl = card.querySelector(".card-product-content__price");
    if (priceEl) priceEl.classList.add("waco-priced");
  }

  function render(card, data) {
    // Default to the cheapest configuration so the price shown matches the card's existing
    // "starting at" value (no jump on load); shoppers configure up from there.
    var sel = { k: data.karats[0], c: data.carats[0], q: data.quals[0] };
    card.__wacoSel = sel;
    card.__wacoData = data;
    var node = priceNode(card);
    if (node) card.__wacoDefaultText = node.textContent.trim();

    var kOpts = data.karats.map(function (v) { return opt(v, v, v, v === sel.k); }).join("");
    var qOpts = data.quals.map(function (v) { return opt(v, qLabel(v), v, v === sel.q); }).join("");

    // card__interactive lifts the block above the theme's full-card expand-link overlay
    // (.expand-link__link::after, position:absolute inset:0 z-index:2) so the controls are
    // clickable — same mechanism the colour-swatch row uses. Options live in a "Customize"
    // disclosure, collapsed by default, to keep the grid calm (the de-clutter from the spec).
    var html = '<div class="waco-cfg card__interactive" data-waco-cfg>' +
      '<button type="button" class="waco-cfg__toggle" data-waco-cfg-toggle aria-expanded="false">' +
        '<span class="waco-cfg__toggle-label">Customize</span>' +
        '<span class="waco-cfg__toggle-icon" aria-hidden="true"></span>' +
      "</button>" +
      '<div class="waco-cfg__panel" data-waco-cfg-panel aria-hidden="true">' +
        toggleField("karat", "Metal Karat", kOpts) +
        caratField(data.carats, sel.c) +
        toggleField("quality", "Diamond Quality", qOpts) +
      "</div></div>";

    var swatches = card.querySelector(".waco-card-swatches");
    var content = card.querySelector(".card-product-content");
    if (swatches) swatches.insertAdjacentHTML("afterend", html);
    else if (content) content.insertAdjacentHTML("beforeend", html);
    reprice(card);
  }

  function initCard(card) {
    if (card.__wacoCfgInit) return;
    var data = parse(card);
    if (!data || !data.karats.length || !data.carats.length || !data.quals.length) return;
    if (!priceNode(card)) return;
    card.__wacoCfgInit = true;
    render(card, data);
  }
  function initAll() {
    var els = document.querySelectorAll(".card-product[data-waco-price-matrix]");
    for (var i = 0; i < els.length; i++) initCard(els[i]);
  }

  // Delegated clicks: text toggles (Karat/Quality) + the Customize disclosure. All live inside the
  // card's expand-link, so stop the click reaching it.
  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest(".waco-cfg__opt");
    if (t) {
      e.preventDefault();
      e.stopPropagation();
      var row = t.closest("[data-waco-cfg-dim]"), card = t.closest(".card-product");
      if (!row || !card || !card.__wacoSel) return;
      var dim = row.getAttribute("data-waco-cfg-dim");
      var key = dim === "karat" ? "k" : "q";
      card.__wacoSel[key] = t.getAttribute("data-waco-cfg-val");
      var opts = row.querySelectorAll(".waco-cfg__opt");
      for (var i = 0; i < opts.length; i++) {
        var on = opts[i] === t;
        opts[i].classList.toggle("is-active", on);
        opts[i].setAttribute("aria-pressed", on ? "true" : "false");
      }
      reprice(card);
      return;
    }
    var tog = e.target.closest && e.target.closest("[data-waco-cfg-toggle]");
    if (tog) {
      e.preventDefault();
      e.stopPropagation();
      var cfg = tog.closest(".waco-cfg");
      var open = !cfg.classList.contains("is-open");
      cfg.classList.toggle("is-open", open);
      tog.setAttribute("aria-expanded", open ? "true" : "false");
      var panel = cfg.querySelector("[data-waco-cfg-panel]");
      if (panel) panel.setAttribute("aria-hidden", open ? "false" : "true");
      var lbl = tog.querySelector(".waco-cfg__toggle-label");
      if (lbl) lbl.textContent = open ? "Close" : "Customize";
    }
  }, true);

  // Carat slider — snap to the nearest real carat, update the readout, reprice.
  document.addEventListener("input", function (e) {
    var s = e.target;
    if (!s || !s.matches || !s.matches(".waco-cfg__slider")) return;
    e.stopPropagation();
    var card = s.closest(".card-product");
    if (!card || !card.__wacoSel || !card.__wacoData) return;
    var v = parseFloat(s.value), carats = card.__wacoData.carats, best = carats[0], bd = Infinity;
    for (var i = 0; i < carats.length; i++) { var d = Math.abs(parseFloat(carats[i]) - v); if (d < bd) { bd = d; best = carats[i]; } }
    if (parseFloat(s.value) !== parseFloat(best)) s.value = best; // snap the thumb to a real carat
    card.__wacoSel.c = best;
    var out = card.querySelector("[data-waco-carat-val]");
    if (out) out.textContent = best + " ct";
    reprice(card);
  }, true);

  // Carry the chosen configuration to the PDP via #waco-config when the card is opened.
  function stamp(e) {
    var link = e.target.closest && e.target.closest(".card-product[data-waco-price-matrix] .expand-link__link");
    if (!link) return;
    var card = link.closest(".card-product"), sel = card && card.__wacoSel;
    if (!sel) return;
    var key = sel.k + "|" + sel.c + "|" + sel.q;
    var href = (link.getAttribute("href") || "").replace(/#waco-config=[^#]*/, "").replace(/#$/, "");
    link.setAttribute("href", href + "#waco-config=" + encodeURIComponent(key));
  }
  document.addEventListener("mousedown", stamp, true);
  document.addEventListener("click", stamp, true);

  // ---------- quick-add modal: preselect the card's configuration ----------
  // The quick-add "bag" opens a mini-PDP <dialog> with the same waco variant picker, but at the
  // product's default options. Read the card's config (colour + karat/carat/quality) and apply it
  // to the modal's picker once it renders, so the shopper doesn't re-pick what they chose on the card.
  function cardFullConfig(card) {
    var sel = card.__wacoSel;
    if (!sel) return null;
    var cfg = { "Metal Karat": sel.k, "Carat Size": sel.c, "Diamond Quality": sel.q };
    var sw = card.querySelector("[data-waco-card-swatch].is-active");
    if (sw) { var col = sw.getAttribute("aria-label") || sw.getAttribute("title"); if (col) cfg["Metal Color"] = col; }
    return cfg;
  }
  // Force ALL four radios to the config and dispatch change on the last — same mechanism as the PDP
  // deep-link. Dispatch every attempt (not only when a radio flips), because the quick-add modal
  // fires two settling renders on open that can reset an early apply back to default.
  function forceApply(picker, cfg) {
    var last = null;
    Object.keys(cfg).forEach(function (name) {
      var val = cfg[name];
      var group = picker.querySelectorAll('input.waco-radio[data-option-name="' + name + '"]');
      if (!group.length) return;
      var target = null;
      for (var i = 0; i < group.length; i++) { if (group[i].value === val) { target = group[i]; break; } }
      if (!target || target.classList.contains("disabled")) return;
      for (var j = 0; j < group.length; j++) group[j].checked = (group[j] === target);
      last = target;
    });
    if (last) last.dispatchEvent(new Event("change", { bubbles: true }));
  }
  function modalAmount(dlg) {
    var el = dlg.querySelector(".price__regular span:not(.visually-hidden)") ||
             dlg.querySelector("product-price") || dlg.querySelector(".price");
    if (!el) return null;
    // Strip thousands separators FIRST, then take the first number — otherwise "$7,575.00" splits
    // on the comma and reads as 7, so the loop never sees the configured price and never stops.
    var m = (el.textContent || "").replace(/,/g, "").match(/\d+(?:\.\d+)?/);
    return m ? Math.round(parseFloat(m[0])) : null;
  }
  document.addEventListener("click", function (e) {
    var qa = e.target.closest && e.target.closest(".card-product__quick-add");
    if (!qa) return;
    var card = qa.closest(".card-product[data-waco-price-matrix]");
    if (!card || !card.__wacoSel || !card.__wacoData) return;
    var cfg = cardFullConfig(card);
    if (!cfg) return;
    var sel = card.__wacoSel;
    var want = card.__wacoData.matrix[sel.k + "|" + sel.c + "|" + sel.q]; // configured price target
    want = want == null ? null : Math.round(want);
    // The modal fires a couple of settling renders on open (viewTransition swaps the picker node).
    // Applying DURING those interleaves with them and the default wins — so only apply when the
    // picker node has been STABLE for ~500ms (no render in flight). After our apply the picker
    // re-renders (node changes), we wait for it to settle again, then confirm the configured price.
    // NB: this handler runs in the capture phase, BEFORE the quick-add button opens the modal — so
    // keep polling (never bail) until the modal's picker appears, then apply once it has settled.
    var tries = 0, lastPicker = null, stable = 0;
    (function loop() {
      if (tries++ > 90) return; // ~20s cap (includes the ~1s the modal takes to open)
      var dlg = document.querySelector("dialog[open]");
      var picker = dlg && dlg.querySelector(".waco-variant-picker");
      if (!picker || !picker.querySelector("input.waco-radio")) { lastPicker = null; stable = 0; setTimeout(loop, 200); return; }
      if (want != null && modalAmount(dlg) === want) return; // configured variant is live — done
      if (picker === lastPicker) stable++; else { lastPicker = picker; stable = 0; }
      if (stable >= 2) { forceApply(picker, cfg); stable = 0; } // settled (no render in flight) → apply
      setTimeout(loop, 250);
    })();
  }, true);

  function boot() {
    initAll();
    // The engagement collection auto-loads later pages (waco-eng-collection.js) — configure those
    // cards as they arrive. Idempotent: initCard skips cards already built, and our price writes
    // never add new [data-waco-price-matrix] cards, so this can't loop.
    if (window.MutationObserver) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; initAll(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
